// ============================================================
// PRESET / CONFIGURAZIONI PLAYER
// ============================================================
/**
 * Identifica il contesto nel quale viene utilizzato il player.
 *
 * Ogni valore corrisponde ad una configurazione presente
 * in videoPlayerConfig.
 */
export var VideoPlayerConfig;
(function (VideoPlayerConfig) {
    VideoPlayerConfig[VideoPlayerConfig["Default"] = 0] = "Default";
    VideoPlayerConfig[VideoPlayerConfig["Reel"] = 1] = "Reel";
    VideoPlayerConfig[VideoPlayerConfig["Preview"] = 2] = "Preview";
    VideoPlayerConfig[VideoPlayerConfig["Live"] = 3] = "Live";
})(VideoPlayerConfig || (VideoPlayerConfig = {}));
/**
 * Configurazioni centralizzate del player.
 *
 */
export const videoPlayerConfig = {
    // ==========================================================
    // DEFAULT - VIDEO
    // ==========================================================
    [VideoPlayerConfig.Default]: {
        options: {
            controls: true,
            responsive: false,
            fluid: false,
            preload: "metadata",
            aspectRatio: "16:9",
            playsinline: true,
            enableSmoothSeeking: true,
            autoplay: true,
            loop: false,
            muted: false,
            /**
             * Configurazione NATIVA Video.js
             * per il menu della velocità.
             */
            playbackRates: [0.5, 1, 2],
            /**
             * Pusalti manda avanti/indietro
             */
            controlBar: {
                skipButtons: {
                    backward: 5,
                    forward: 5,
                },
                children: [
                    "playToggle",
                    "skipBackward",
                    "skipForward",
                    "volumePanel",
                    "progressControl",
                    "currentTimeDisplay",
                    "timeDivider",
                    "durationDisplay",
                    "customControlSpacer",
                    "subsCapsButton",
                    "fullscreenToggle",
                ],
            },
            /**
             * Configurazione custom equivalente a quella
             * precedentemente presente nei params di PlayerJS.
             */
            speed: {
                default: 1,
                options: [0.5, 1, 2],
            },
            /**
             * caption viene aggiunto dinamicamente da VideoPlayer2
             * perché dipende dal contenuto corrente.
             *
             * redirectOnVideoEnded viene anch'esso aggiunto
             * dinamicamente perché dipende da getAutoplay().
             */
            duration: 0,
        },
    },
    // ==========================================================
    // LIVE
    // ==========================================================
    [VideoPlayerConfig.Live]: {
        options: {
            controls: true,
            responsive: true,
            fluid: false,
            preload: "metadata",
            aspectRatio: "16:9",
            playbackRateMenuButton: false,
            playsinline: true,
            autoplay: true,
            loop: false,
            muted: false,
            /**
             * caption viene aggiunto dinamicamente da VideoPlayer2
             * perché dipende dal contenuto corrente.
             *
             * redirectOnVideoEnded viene anch'esso aggiunto
             * dinamicamente perché dipende da getAutoplay().
             */
        },
    },
    // ==========================================================
    // REEL
    // ==========================================================
    [VideoPlayerConfig.Reel]: {
        options: {
            controls: true,
            responsive: true,
            fluid: true,
            aspectRatio: "3:4",
            enableRightButtons: true,
            isAdsActive: false,
            autoplay: true,
            loop: true,
            muted: true,
            playbackRates: [0.5, 1, 1.5, 2],
            controlBar: {
                skipButtons: {
                    backward: 10,
                    forward: 10,
                },
                children: [
                    "playToggle",
                    "skipBackward",
                    "skipForward",
                    "volumePanel",
                    "progressControl",
                    "currentTimeDisplay",
                    "timeDivider",
                    "durationDisplay",
                    "customControlSpacer",
                    "subsCapsButton",
                    "fullscreenToggle",
                ],
            },
        },
    },
    // ==========================================================
    // PREVIEW
    // ==========================================================
    [VideoPlayerConfig.Preview]: {
        options: {
            controls: false,
            responsive: true,
            fluid: true,
            autoplay: true,
            loop: true,
            muted: true,
        },
    },
};
